/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
import { useOnClickOutside } from "../../CommonMethods/OutsideClick";
import { ShimmerTitle } from 'react-shimmer-effects'
import moment from "moment";

const Shimmer = () => (
    <div className="animate-pulse">
        {/* <div className="bg-gray-300 h-4 w-full mb-2 rounded"></div>
        <div className="bg-gray-300 h-4 w-full mb-2 rounded"></div>
        <div className="bg-gray-300 h-4 w-full mb-2 rounded"></div> */}
    </div>
);

const FeeStructureDropdown = ({
    placeHolder,
    id,
    isFeeStructure,
    divClassName,
    options,
    handleOnchangeInput,
    value,
    dropDownName,
    index,
    buttonDisabled,
    buttonClassName,
    tooltip,
    outSideClickTriggered,
    test_id,
    showErrorBorder,
    isMandatoryField,
    applyBGForDisabled,
    isDisplay,
    loading, 
}) => {
    const [isOpen, setisOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const listRef = useRef(null);

    useOnClickOutside(ref, () => {
        setisOpen(false);
    });

    const calculateDropdownPosition = () => {
        if (!buttonRef.current || !dropdownRef.current) return;
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - buttonRect.bottom - 40;
        const dropdownHeight = dropdownRef.current.clientHeight;

        if (spaceBelow < dropdownHeight) {
            dropdownRef.current.style.top = `-${dropdownHeight}px`;
        } else {
            dropdownRef.current.style.top = '100%';
        }
    };

    useEffect(() => {
        if (isOpen) {
            calculateDropdownPosition();
            setHighlightedIndex(0);
            setTimeout(() => listRef.current?.focus(), 0);
        }
        window.addEventListener('resize', calculateDropdownPosition);
        return () => {
            window.removeEventListener('resize', calculateDropdownPosition);
        };
    }, [isOpen]);

    useEffect(() => {
        setisOpen(false);
    }, [outSideClickTriggered]);

    const handleButtonKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setisOpen(!isOpen);
        }
    };

    const handleListKeyDown = (e) => {
        e.stopPropagation();
        if (!isOpen) return;
    
        switch (e.key) {
        case 'ArrowDown':
            e.preventDefault();
            setHighlightedIndex((prevIndex) => (prevIndex + 1) % (options?.length || 1));
            break;
        case 'ArrowUp':
            e.preventDefault();
            setHighlightedIndex((prevIndex) => (prevIndex - 1 + (options?.length || 1)) % (options?.length || 1));
            break;
        case 'Enter':
            e.preventDefault();
            if (highlightedIndex >= 0 && options[highlightedIndex]) {
                handleOnchangeInput(dropDownName, options[highlightedIndex], index);
                setisOpen(false);
                buttonRef.current?.focus();
            }
            break;
        case 'Escape':
            e.preventDefault();
            setisOpen(false);
            buttonRef.current?.focus();
            break;
        default:
            break;
        }
    };
    
    useEffect(() => {
        if (isOpen && listRef.current && highlightedIndex >= 0) {
            const el = listRef.current.children[highlightedIndex];
            if (el) {
                el.scrollIntoView({ block: 'nearest' });
            }
        }
    }, [highlightedIndex, isOpen, options]);

    return (
        <div className={`w-full relative `} data-te-dropdown-ref id={id} ref={ref}>
            <button
                ref={buttonRef}
                disabled={buttonDisabled !== undefined && buttonDisabled}
                title={tooltip !== undefined && tooltip ? value?.split('(')[1]?.split(')')[0] : value}
                onClick={() => setisOpen(!isOpen)}
                onKeyDown={handleButtonKeyDown}
                className={`slct-inpt-fld transition duration-150 ease-in-out ${showErrorBorder == true ? 'redBorder' : ''}
                 ${(isMandatoryField!=undefined && isMandatoryField === true) ? ' error_border ' : ''}
                 ${buttonDisabled !== undefined && buttonDisabled && applyBGForDisabled ? 'bg-[#E6E8EA]' : 'bg-white'}`}
                type="button"
                id={dropDownName}
                data-testid={test_id}
                data-te-dropdown-toggle-ref
                aria-expanded="false"
            >
                <p
                    className={`text-f7 ${
                        (value === "" || value === undefined || value === true)
                            ? "text-[#818E98]"
                            : "text-[#031624]"
                    } font-normal `}
                >
                    {(value === "" || value === undefined || value === true)
                        ? placeHolder
                        : value}
                </p>
                <img
                    src="/images/dropdown-icon.png"
                    alt="icon"
                    className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${
                        isOpen ? "transform rotate-180" : ""
                    }`}
                />
            </button>
            <ul
                ref={dropdownRef}
                tabIndex="-1"
                className={`ant-picker-dropdown slct_drp_dwn min-w-full ${
                    isOpen ? "" : "hidden"
                }  [&[data-te-dropdown-show]]:block focus:outline-none`}
                aria-labelledby="dropdownMenu_acdemic_year"
                data-te-dropdown-menu-ref
                title={tooltip && value?.split('(')[1]?.split(')')[0]}
            >
                <li className="max-h-[220px] overflow-auto scroll-bar">
                    <ul ref={listRef} onKeyDown={handleListKeyDown} tabIndex={-1} className="focus:outline-none">
                        {loading ? (
                            <li className="max-h-[150px] overflow-auto scroll-bar" style={{ 'padding': '0.3rem 0.5rem' }}>
                                <p className="text-2xl font-bold text-[#031624] mb-4 mt-4"><ShimmerTitle line={1} gap={6} variant="secondary" /></p>
                            </li>
                        ) : (
                            options?.length > 0 ? (
                                options.map((option, i) => (
                                    <li
                                        key={i}
                                        id={
                                            isFeeStructure === undefined
                                                ? dropDownName
                                                : id + "_" + dropDownName + i
                                        }
                                        onClick={(e) => {
                                            handleOnchangeInput(dropDownName, option, index),
                                            setisOpen(false);
                                        }}
                                        className={highlightedIndex === i ? "bg-gray-100" : ""}
                                    >
                                        <a
                                            title={
                                                option.start_date
                                                    ? `${option.name} (${moment(option.start_date)
                                                        .utcOffset('+00:00')
                                                        .format('MMM DD, YYYY')} - ${moment(option.end_date)
                                                        .utcOffset('+00:00')
                                                        .format('MMM DD, YYYY')})  (${option?.status
                                                        ?.charAt(0)
                                                        ?.toUpperCase() + option?.status?.slice(1)})`
                                                    : option.name
                                            }
                                            className="cursor-pointer w-full bg-transparent px-2 pt-2 mb-2 text-f7 font-normal text-[#031624] more-lines break-words"
                                            style={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            {(value && option.name && (dropDownName === 'academic_year' ? value.startsWith(option.name) : value === option.name))
                                                ? <img src="/images/bluedot.svg" alt="selected" className="mr-2 shrink-0"/>
                                                : <div className="w-[7px] h-[6px] mr-2 shrink-0"></div>
                                            }
                                            <span>
                                                {dropDownName === "academic_year"
                                                    ? `${option.name} (${option?.status
                                                        ?.charAt(0)
                                                        ?.toUpperCase() + option?.status?.slice(1)})`
                                                    : option.name}
                                            </span>
                                        </a>
                                    </li>
                                ))) :
                                (
                                    <li
                                        key=""
                                        id="select-option"
                                        onClick={(e) => {
                                            setisOpen(false);
                                        }}
                                    >
                                        <a className="slct_drp_dwn_optn">
                                            - No options available -
                                        </a>
                                    </li>
                                )
                        )}
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default FeeStructureDropdown;
